export const COPY = {
  title: 'Set up your password',
  validation: {
    heading: 'Your password must contain:',
    characters: 'At least 8 characters',
    upperCase: '1 upper case letter',
    numbers: '2 numbers',
    specialSymbols: 'No special symbols',
    error: {
      heading: 'Invalid password',
      message: 'Please ensure the new password follows the guidance'
    }
  },
  button: 'Continue'
}
